import { jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import useArchiveDeleteGlobalHandler from "./useArchiveDeleteGlobalHandler";
import useFocusWhenGlobalHandler from "./useFocusWhenGlobalHandler";
import useMarkCompleteGlobalHandler from "./useMarkCompleteGlobalHandler";
import useMoveGlobalHandler from "./useMoveGlobalHandler";
import useWhenOrDeadlineGlobalHandler from "./useWhenOrDeadlineGlobalHandler";
export default function useBaseGlobalActionHandler({ posts , sections , onActionHandled  }) {
    useArchiveDeleteGlobalHandler();
    useFocusWhenGlobalHandler();
    useMarkCompleteGlobalHandler();
    const items = useMemo(()=>{
        return [
            ...posts,
            ...sections !== null && sections !== void 0 ? sections : []
        ];
    }, [
        posts,
        sections
    ]);
    const whenOrDeadlineDialogs = useWhenOrDeadlineGlobalHandler({
        posts,
        onActionHandled
    });
    const moveDialog = useMoveGlobalHandler({
        items
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            whenOrDeadlineDialogs,
            moveDialog
        ]
    });
};
